export default "__VITE_ASSET__C7YG4uKn__"